import {
    AbacoWebModule,
    RouterReadyEvent,
    VueRouter,
    ApplicationReadyEvent,
    MenuItem
} from "@abaco/web-common/src/app";
import globals from "./globals";
import myRoutes from "./routes";
import LayerManagementVuexModule from "./state";
import { HTTPClient } from "@abaco/web-common/src/HTTP";
import { createMenu } from "./menu";
import LayerApi from "./api/LayerApi";
import MapWebModule from "@abaco/map-web-module/src/modules/map-web-module";
import FarmRegistryModule from "@abaco/farm-registry/src/modules/farm-registry/index";
import LayerParser from "./LayerParser";
import DashboardModule from "@abaco/dashboard-module/src/modules/dashboard";

export const MODULE_ID = "layer_management_module";

export default class LayerManagementModule implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;

    private layerParser!: LayerParser;
    private lyrApi!: LayerApi;

    private router!: VueRouter;
    private http!: HTTPClient;

    readonly id = MODULE_ID;
    readonly routes = myRoutes;
    readonly globalComponents = globals;
    readonly vuexModule = new LayerManagementVuexModule();
    menu: MenuItem[] = [];

    dependsOn = {
        [MapWebModule.MODULE_ID]: () => new MapWebModule(),
        [FarmRegistryModule.MODULE_ID]: () => new FarmRegistryModule(),
        [DashboardModule.MODULE_ID]: () => new DashboardModule()
    };

    onRouterReady(evt: RouterReadyEvent) {
        this.router = evt.router;
        this.menu = createMenu(this.router);
    }

    onApplicationReady(evt: ApplicationReadyEvent) {
        this.http = evt.http;
    }

    async beforeEnterAnyRoutes(http: HTTPClient) {
        const LayerParser = (await import("./LayerParser")).default;
        this.layerParser = new LayerParser();

        const LayerApi = (await import("./api/LayerApi")).default;
        this.lyrApi = new LayerApi(http);
    }

    public get layerApi() {
        return this.lyrApi;
    }

    public get LayerParser(): LayerParser {
        return this.layerParser;
    }
}
